// extracted by mini-css-extract-plugin
export default {"base":"Footer_base__jFq3S","lukoil":"Footer_lukoil__ZqYhO","footer":"Footer_footer__MOFZ6","footer_body":"Footer_footer_body__m+ETP","footer_nav":"Footer_footer_nav__LpuWE"};